import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import ContentArea from '../../components/contentArea';
import { formatDateTimeDisplay } from '../../utils/base';
import { useTheme } from '@mui/material/styles';

export const NoticeDetail = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();
    const theme = useTheme();
    const notice = location.state?.notice;

    if (!notice) {
        return null; // or some loading/error state
    }

    return (
        <ContentArea>
            {/* 공지사항 상세 */}
            <Box
                sx={{
                    padding: '0px 20px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    flex: 1,
                    alignSelf: 'stretch',
                    minHeight: 0,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        minWidth: '280px',
                        padding: '20px 0px 10px 0px',
                        alignItems: 'center',
                        gap: '5px',
                        alignSelf: 'stretch',
                        borderBottom: '1px solid ' + theme.palette.figma?.white?.[30] || 'rgba(255, 255, 255, 0.3)',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                            gap: '10px',
                            flex: 1,
                            alignSelf: 'stretch',
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                color: theme.palette.text?.primary || 'rgba(255, 255, 255, 0.9)',
                                fontSize: '15px',
                                fontWeight: 500,
                                lineHeight: 'normal',
                                textAlign: 'left',
                            }}
                        >
                            {notice?.title || ''}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                overflow: 'hidden',
                                color: theme.palette.text?.secondary || 'rgba(255, 255, 255, 0.4)',
                                textOverflow: 'ellipsis',
                                fontSize: '12px',
                                fontStyle: 'normal',
                                fontWeight: 500,
                                lineHeight: 'normal',
                            }}
                        >
                            {formatDateTimeDisplay(
                                notice?.startDate || notice?.createDate,
                                'datetime'
                            )}
                        </Typography>
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        minWidth: '280px',
                        padding: '20px 0px',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        gap: '5px',
                        alignSelf: 'stretch',
                    }}
                >
                    <Typography
                        variant="body1"
                        sx={{
                            alignSelf: 'stretch',
                            color: theme.palette.text?.primary || 'rgba(255, 255, 255, 0.9)',
                            fontSize: '15px',
                            fontStyle: 'normal',
                            fontWeight: 500,
                            lineHeight: 'normal',
                            textAlign: 'left',
                        }}
                    >
                        {notice?.content || ''}
                    </Typography>
                    {notice?.file && (
                        <Box
                            component="img"
                            src={notice.file}
                            alt="첨부파일"
                            sx={{
                                mt: 2,
                                maxWidth: '100%',
                                maxHeight: '300px',
                                objectFit: 'contain',
                                borderRadius: '8px',
                            }}
                        />
                    )}
                </Box>
            </Box>
        </ContentArea>
    );
};

export default NoticeDetail;
